import { useQuery } from "@tanstack/vue-query";
import { ImageOrigin } from "mws-ts-v2-sdk";

import { queries } from "~/queries";

/**
 * Composable for 360° product viewer configuration
 * @returns Object with demo configuration for 360° viewer
 */
export const use360Viewer = (productIdentifier: MaybeRefOrGetter<string>) => {
  const platformStore = usePlatformStore();
  const platformId = computed(
    () => platformStore.getPlatformConfiguration.platformId,
  );
  const { isLoggedIn } = useAuth();

  const { data: productDetails } = useQuery(
    queries.products.details(productIdentifier, platformId),
  );

  const image360Url = computed(() => {
    return productDetails.value?.image360Url;
  });

  const { result: shouldShow360, loaded: growthbookLoaded } = useGrowthbook({
    feature: "360-viewer-web",
    fallback: false,
  });

  const has360Images = computed(() => {
    if (!platformStore.isMatchWornShirt) return false;

    if (
      productDetails.value?.media.some(
        (item) => item.metadata?.origin === ImageOrigin.Mockup,
      )
    ) {
      return false;
    }

    return !!image360Url.value?.length;
  });

  const show360Viewer = computed(() => {
    if (!growthbookLoaded.value) return false;

    return shouldShow360.value && isLoggedIn.value && has360Images.value;
  });

  return {
    image360Url,
    has360Images,
    show360Viewer,
  };
};
